import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import baseTheme from './theme';

export const useThemeMode = () => ({ mode: 'light', toggle: () => {} });

export default function AppThemeProvider({ children }) {
  return (
    <ThemeProvider theme={baseTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
